import { defineMessages } from 'react-intl';

export default defineMessages({
    loading: {
        id: 'renewal.ea.views.riskAnalysis.Loading changes...',
        defaultMessage: 'Loading changes...'
    },
    ratingYourPolicyMessage: {
        id: 'renewal.ea.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    loadingNextPageMessage: {
        id: 'renewal.ea.views.riskAnalysis.Loading next Page...',
        defaultMessage: 'Loading next page...'
    },
    priorCarrier: {
        id: 'renewal.ea.views.riskAnalysis.Prior Carrier',
        defaultMessage: 'Prior Carrier'
    },
    lossesAndViolations: {
        id: 'renewal.ea.views.riskAnalysis.Driver Activity',
        defaultMessage: 'Driver Activity'
    },
    vehicleReport: {
        id: 'renewal.ea.views.riskAnalysis.Vehicle Report',
        defaultMessage: 'Vehicle Report'
    },
    miscellaneousReports: {
        id: 'renewal.ea.views.riskAnalysis.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    credit: {
        id: 'renewal.ea.views.riskAnalysis.Credit',
        defaultMessage: 'Credit'
    },
    reportsErrorTitle: {
        id: 'renewal.ea.views.riskAnalysis.Error Retrieving Auto Losses',
        defaultMessage: 'Error Retrieving Auto Losses'
    },
    reportsErrorMessage: {
        id: 'renewal.ea.views.riskAnalysis.An error occurred attempting to retrieving Auto Losses.',
        defaultMessage: 'An error occurred attempting to retrieving Auto Losses.'
    },
    Premium: {
        id: 'renewal.ea.views.riskAnalysis.Premium',
        defaultMessage: 'Premium'
    }
});
